import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import $ from 'jquery';
import whatInput from 'what-input';

const $pricingTable = $('[data-pricing]');
const pricingData = $pricingTable.data('pricing');
const $currencyToggle = $('[data-change-currency]');
let activeCurrency = $currencyToggle.data('initial-currency');

function setSubscriptionLinkTargets(activeData) {
  $('[data-subscription]').each((index, element) => {
    const $linkButton = $(element);
    $linkButton.attr(
      'href',
      activeData[$linkButton.data('subscription-type')][$linkButton.data('subscription')].url,
    );
  });
}

function setPricesHtml(activeData) {
  $('[data-price]').each((index, element) => {
    $('[data-price-amount="regular"]', element)
      .html(activeData.regular[$(element).data('price')].price);
    $('[data-price-amount="academy"]', element)
      .html(activeData.academy[$(element).data('price')].price);
    $('[data-price-amount="academyFee"]', element).html(activeData.academyFee);
    $('[data-price-interval]', element).html(`/${activeData.intervalLabel}`);
  });
}

$('[data-change-interval]')
  .on('change', () => {
    const activeData = pricingData[activeCurrency][$('[data-change-interval]').is(':checked')
      ? 'yearly'
      : 'monthly'];
    setSubscriptionLinkTargets(activeData);
    setPricesHtml(activeData);
  });

$currencyToggle
  .attr('role', 'button')
  .on('click', (e) => {
    e.preventDefault();
    activeCurrency = activeCurrency === 'USD' ? 'EUR' : 'USD';
    const activeData = pricingData[activeCurrency][$('[data-change-interval]').is(':checked')
      ? 'yearly'
      : 'monthly'];

    $(e.target).html(activeData.toggleCurrencyToLinkText);
    $('[data-change-currency-aria]').html(activeData.alertText);
    setPricesHtml(activeData);
  });

const $pricingTableContainer = $('.pricing-table-container');

function setPricingTableOffset(activeColumn) {
  $pricingTable.css('transform', `translateX(${(activeColumn / 3) * -100}%)`);
}

function pricingTableSlider(inputType) {
  if ((inputType === 'touch' || inputType === 'initial') && MediaQuery.only('small')) {
    const ltr = $('html').attr('dir') === 'ltr';
    let activeColumn = 0;
    let startX = 0;
    let startY = 0;
    setPricingTableOffset(activeColumn);

    const handleSwipes = (changedTouches) => {
      const maxColumn = ltr ? 2 : 0;
      const minColumn = ltr ? 0 : -2;
      const diffX = changedTouches[0].screenX - startX;
      const diffY = changedTouches[0].screenY - startY;
      const ratioX = Math.abs(diffX / diffY);
      const ratioY = Math.abs(diffY / diffX);
      const swipeTreshold = Math.abs(ratioX > ratioY ? diffX : diffY);

      if (swipeTreshold < 30) {
        return;
      }

      if (ratioX > ratioY) {
        if (diffX >= 0) {
          activeColumn = Math.max(activeColumn -= 1, minColumn);
        } else {
          activeColumn = Math.min(activeColumn += 1, maxColumn);
        }
      }

      setPricingTableOffset(activeColumn);
    };
    $pricingTableContainer
      .addClass('pricing-table-container--swipe-init');

    $pricingTableContainer[0].addEventListener('touchstart', ({ changedTouches }) => {
      startX = changedTouches[0].screenX;
      startY = changedTouches[0].screenY;
    }, { passive: true });

    $pricingTableContainer[0].addEventListener('touchend', ({ changedTouches }) => {
      handleSwipes(changedTouches);
    }, { passive: true });
  } else {
    $pricingTableContainer.removeClass('pricing-table-container--swipe-init');
    setPricingTableOffset(0);
  }
}

pricingTableSlider(whatInput.ask());

whatInput.registerOnChange(() => {
  pricingTableSlider(whatInput.ask());
}, 'input');
